import * as THREE from "three";
import Experience from "../../../Experience.js";

export default class Fog {
    constructor(fogColor) {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.debug = this.experience.debug;

        const fogClr = fogColor || new THREE.Color("#1e4f9f");
        this.params = {
            // convert this back to sRGB space to see same hexcode you set originally in code
            color: fogClr.getHex(THREE.SRGBColorSpace),
            near: 1,
            far: 200,
        };

        this.instance = new THREE.Fog(
            fogClr,
            this.params.near,
            this.params.far,
        );
        this.scene.fog = this.instance;
        this.scene.background = this.instance.color;

        if (this.debug.active) {
            this.setDebug();
        }
    }

    setDebug() {
        this.debugFolder = this.debug.ui.addFolder("Fog");

        this.debugFolder.addColor(this.params, "color").onChange((v) => {
            // as scene.background references the same color object as scene.fog.color, we only need to set the color once
            this.instance.color.setHex(v, THREE.SRGBColorSpace);
        });

        this.debugFolder
            .add(this.params, "near")
            .min(0)
            .max(100)
            .step(0.1)
            .onChange(() => {
                this.instance.near = this.params.near;
            });

        this.debugFolder
            .add(this.params, "far")
            .min(0)
            .max(500)
            .step(0.1)
            .onChange(() => {
                this.instance.far = this.params.far;
            });
    }
}
